import { Moon, Sun } from 'lucide-react';

import { useTheme } from '../theme/theme-provider';

/** Sized and bordered to match GlobalSearch so the two sit flush together. */
export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}
      className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md border border-input bg-card text-muted-foreground shadow-xs transition-colors duration-150 ease-out hover:text-foreground focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 focus-visible:ring-offset-2 focus-visible:ring-offset-background"
    >
      {theme === 'dark' ? <Moon className="h-4 w-4" /> : <Sun className="h-4 w-4" />}
    </button>
  );
}
